/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { Row, Col, message } from "antd";
import Layout from "../../../layouts/MocoLayout";
import { NavigationMenuCard } from "../../../components/ui";
import { ChartCard } from "../../../components/widget";
import oRest from "../../../apis/rest";
import config from "./index.config";
import "./index.scss";

const API_URL = "webhook/dataquery/?qname=";

const Page = () => {
  const [cards, setCards] = useState(config.cards);

  const getUrl = (query, limit) => {
    return `${API_URL}${query}&limit=${limit}`;
  };

  const toPascalCase = (params) => {
    return params.charAt(0).toUpperCase() + params.slice(1).toLowerCase();
  };

  // Sebaran Provinsi
  useEffect(() => {
    const url = getUrl(
      cards.chart.sebaranProvinsi.queryName,
      cards.chart.sebaranProvinsi.state.limit
    );

    const fetchData = () => {
      oRest
        .get(url)
        .then(({ data }) => {
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              sebaranProvinsi: {
                ...card.chart.sebaranProvinsi,
                state: {
                  ...card.chart.sebaranProvinsi.state,
                  data,
                },
                options: {
                  ...card.chart.sebaranProvinsi.options,
                  dataSource: data.map((e, idx) => {
                    return {
                      ...e,
                      id: idx,
                    };
                  }),
                  chartOption: {
                    ...card.chart.sebaranProvinsi.options.chartOption,
                    dataset: [
                      {
                        ...card.chart.sebaranProvinsi.options.chartOption
                          .dataset[0],
                        source: data.map((e) => {
                          return [toPascalCase(e.name), e.value];
                        }),
                      },
                      {
                        ...card.chart.sebaranProvinsi.options.chartOption
                          .dataset[1],
                      },
                    ],
                  },
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };

    fetchData();
  }, []);

  // Sebaran Kabupaten
  useEffect(() => {
    const fetchData = () => {
      const url = getUrl(
        cards.chart.sebaranKabupaten.queryName,
        cards.chart.sebaranKabupaten.state.limit
      );

      oRest
        .get(url)
        .then(({ data }) => {
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              sebaranKabupaten: {
                ...card.chart.sebaranKabupaten,
                options: {
                  ...card.chart.sebaranKabupaten.options,
                  chartOption: {
                    ...card.chart.sebaranKabupaten.options.chartOption,
                    series: [
                      {
                        ...card.chart.sebaranKabupaten.options.chartOption
                          .series[0],
                        data: data.map((e, idx) => {
                          return {
                            id: idx,
                            name: toPascalCase(e.name),
                            value: e.value,
                            symbolSize: 75,
                          };
                        }),
                      },
                    ],
                  },
                },
                state: {
                  ...card.chart.sebaranKabupaten.state,
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi Kesalahan");
        });
    };

    fetchData();
  }, []);

  // Sebaran Bentuk Usaha
  useEffect(() => {
    const url = getUrl(
      cards.chart.sebaranBentukUsaha.queryName,
      cards.chart.sebaranBentukUsaha.state.limit
    );

    const fetchData = () => {
      oRest
        .get(url)
        .then(({ data }) => {
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              sebaranBentukUsaha: {
                ...card.chart.sebaranBentukUsaha,
                options: {
                  ...card.chart.sebaranBentukUsaha.options,
                  dataSource: data.map((e, idx) => {
                    return {
                      ...e,
                      name: e.name ? toPascalCase(e.name) : "Bentuk lainnya",
                      id: idx,
                    };
                  }),
                  chartOption: {
                    ...card.chart.sebaranBentukUsaha.options.chartOption,
                    dataset: [
                      {
                        ...card.chart.sebaranBentukUsaha.options.chartOption
                          .dataset[0],
                        source: data.map((e) => {
                          return [
                            e.name ? toPascalCase(e.name) : "Bentuk lainnya",
                            e.value,
                          ];
                        }),
                      },
                      {
                        ...card.chart.sebaranBentukUsaha.options.chartOption
                          .dataset[1],
                      },
                    ],
                  },
                },
                state: {
                  ...card.chart.sebaranBentukUsaha.state,
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };

    fetchData();
  }, []);

  // Sebaran Jenis Usaha
  useEffect(() => {
    const url = getUrl(
      cards.chart.sebaranJenisUsaha.queryName,
      cards.chart.sebaranJenisUsaha.state.limit
    );

    const fetchData = () => {
      oRest
        .get(url)
        .then(({ data }) => {
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              sebaranJenisUsaha: {
                ...card.chart.sebaranJenisUsaha,
                options: {
                  ...card.chart.sebaranJenisUsaha.options,
                  dataSource: data.map((e, idx) => {
                    return {
                      ...e,
                      name: e.name ? toPascalCase(e.name) : "Lainnya",
                      id: idx,
                    };
                  }),
                  chartOption: {
                    ...card.chart.sebaranJenisUsaha.options.chartOption,
                    dataset: [
                      {
                        ...card.chart.sebaranJenisUsaha.options.chartOption
                          .dataset[0],
                        source: data.map((e) => {
                          return [
                            e.name ? toPascalCase(e.name) : "Lainnya",
                            e.value,
                          ];
                        }),
                      },
                      {
                        ...card.chart.sebaranJenisUsaha.options.chartOption
                          .dataset[1],
                      },
                    ],
                  },
                },
                state: {
                  ...card.chart.sebaranJenisUsaha.state,
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };

    fetchData();
  }, []);

  // Sebaran Ormas
  useEffect(() => {
    const fetchData = () => {
      const url = getUrl(
        cards.chart.sebaranOrmas.queryName,
        cards.chart.sebaranOrmas.state.limit
      );

      oRest
        .get(url)
        .then(({ data }) => {
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              sebaranOrmas: {
                ...card.chart.sebaranOrmas,
                options: {
                  ...card.chart.sebaranOrmas.options,
                  dataSource: data.map((e, idx) => {
                    return {
                      ...e,
                      name: e.name ? toPascalCase(e.name) : "Lainnya",
                      id: idx,
                    };
                  }),
                  chartOption: {
                    ...card.chart.sebaranOrmas.options.chartOption,
                    series: [
                      {
                        ...card.chart.sebaranOrmas.options.chartOption
                          .series[0],
                        data: data.map((e) => {
                          return {
                            name: e.name ? toPascalCase(e.name) : "Lainnya",
                            value: e.value,
                          };
                        }),
                      },
                    ],
                  },
                },
                state: {
                  ...card.chart.sebaranOrmas.state,
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi Kesalahan");
        });
    };
    fetchData();
  }, []);

  // Sebaran Asosiasi
  useEffect(() => {
    const url = getUrl(
      cards.chart.sebaranAsosiasi.queryName,
      cards.chart.sebaranAsosiasi.state.limit
    );

    const fetchData = () => {
      oRest
        .get(url)
        .then(({ data }) => {
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              sebaranAsosiasi: {
                ...card.chart.sebaranAsosiasi,
                options: {
                  ...card.chart.sebaranAsosiasi.options,
                  dataSource: data.map((e, idx) => {
                    return {
                      ...e,
                      name: e.name ? toPascalCase(e.name) : "Tidak ada",
                      id: idx,
                    };
                  }),
                  chartOption: {
                    ...card.chart.sebaranAsosiasi.options.chartOption,
                    dataset: [
                      {
                        ...card.chart.sebaranAsosiasi.options.chartOption
                          .dataset[0],
                        source: data.map((e) => {
                          return [
                            e.name ? toPascalCase(e.name) : "Tidak ada",
                            e.value,
                          ];
                        }),
                      },
                      {
                        ...card.chart.sebaranAsosiasi.options.chartOption
                          .dataset[1],
                      },
                    ],
                  },
                },
                state: {
                  ...card.chart.sebaranAsosiasi.state,
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };

    fetchData();
  }, []);

  return (
    <section id="PemberdayaanMasyarakat">
      <Layout>
        <NavigationMenuCard
          menu={[
            { title: "Sebaran", path: "/pondok-pesantren" },
            { title: "Pendidikan", path: "/pondok-pesantren/pendidikan" },
            { title: "Dakwah", path: "/pondok-pesantren/dakwah" },
            {
              title: "Pemberdayaan Masyarakat",
              path: "/pondok-pesantren/pemberdayaan-masyarakat",
            },
            {
              title: "Penyajian dan Pencarian",
              path: "/pondok-pesantren/penyajian-pencarian",
            },
          ]}
        />
        <Row
          justify="space-between"
          align="top"
          gutter={[24, 24]}
          style={{ marginTop: 24, marginBottom: 24 }}
        >
          <Col span={16}>
            <Row gutter={[24, 24]}>
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }}>
                <ChartCard {...cards.chart.sebaranJenisUsaha} />
              </Col>
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }}>
                <ChartCard {...cards.chart.sebaranOrmas} />
              </Col>
              <Col span={24}>
                <ChartCard {...cards.chart.sebaranAsosiasi} />
              </Col>
              <Col span={24}>
                <ChartCard {...cards.chart.sebaranBentukUsaha} />
              </Col>
            </Row>
          </Col>
          <Col span={8}>
            <Row gutter={[24, 24]}>
              <Col span={24} className="card__provinsi">
                <ChartCard {...cards.chart.sebaranProvinsi} />
              </Col>
              <Col span={24} className="card__kabupaten">
                <ChartCard {...cards.chart.sebaranKabupaten} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Layout>
    </section>
  );
};

export default Page;
